import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { contentEqualsaf55p28mnw74 as contentEquals } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DescriptionClass;
function Description() {
  if (DescriptionClass === VOID) {
    class $ {
      constructor(text) {
        this.h3i_1 = text;
      }
      equals(other) {
        if (!(other instanceof Description()))
          return false;
        var tmp0_other_with_cast = other instanceof Description() ? other : THROW_CCE();
        if (!(this.h3i_1 === tmp0_other_with_cast.h3i_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('text'), 127) ^ getStringHashCode(this.h3i_1);
      }
      toString() {
        return '@com.lightningkite.lightningdb.Description(' + 'text=' + this.h3i_1 + ')';
      }
    }
    initMetadataForClass($, 'Description');
    DescriptionClass = $;
  }
  return DescriptionClass;
}
var DisplayNameClass;
function DisplayName() {
  if (DisplayNameClass === VOID) {
    class $ {
      constructor(text) {
        this.y3h_1 = text;
      }
      equals(other) {
        if (!(other instanceof DisplayName()))
          return false;
        var tmp0_other_with_cast = other instanceof DisplayName() ? other : THROW_CCE();
        if (!(this.y3h_1 === tmp0_other_with_cast.y3h_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('text'), 127) ^ getStringHashCode(this.y3h_1);
      }
      toString() {
        return '@com.lightningkite.lightningdb.DisplayName(' + 'text=' + this.y3h_1 + ')';
      }
    }
    initMetadataForClass($, 'DisplayName');
    DisplayNameClass = $;
  }
  return DisplayNameClass;
}
var DoesNotNeedLabelClass;
function DoesNotNeedLabel() {
  if (DoesNotNeedLabelClass === VOID) {
    class $ {
      equals(other) {
        if (!(other instanceof DoesNotNeedLabel()))
          return false;
        other instanceof DoesNotNeedLabel() || THROW_CCE();
        return true;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '@com.lightningkite.lightningdb.DoesNotNeedLabel(' + ')';
      }
    }
    initMetadataForClass($, 'DoesNotNeedLabel');
    DoesNotNeedLabelClass = $;
  }
  return DoesNotNeedLabelClass;
}
var MultilineClass;
function Multiline() {
  if (MultilineClass === VOID) {
    class $ {
      equals(other) {
        if (!(other instanceof Multiline()))
          return false;
        other instanceof Multiline() || THROW_CCE();
        return true;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '@com.lightningkite.lightningdb.Multiline(' + ')';
      }
    }
    initMetadataForClass($, 'Multiline');
    MultilineClass = $;
  }
  return MultilineClass;
}
var DenormalizedClass;
function Denormalized() {
  if (DenormalizedClass === VOID) {
    class $ {
      constructor(calculationId) {
        calculationId = calculationId === VOID ? '' : calculationId;
        this.g3i_1 = calculationId;
      }
      equals(other) {
        if (!(other instanceof Denormalized()))
          return false;
        var tmp0_other_with_cast = other instanceof Denormalized() ? other : THROW_CCE();
        if (!(this.g3i_1 === tmp0_other_with_cast.g3i_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('calculationId'), 127) ^ getStringHashCode(this.g3i_1);
      }
      toString() {
        return '@com.lightningkite.lightningdb.Denormalized(' + 'calculationId=' + this.g3i_1 + ')';
      }
    }
    initMetadataForClass($, 'Denormalized');
    DenormalizedClass = $;
  }
  return DenormalizedClass;
}
var IndexClass;
function Index() {
  if (IndexClass === VOID) {
    class $ {
      equals(other) {
        if (!(other instanceof Index()))
          return false;
        other instanceof Index() || THROW_CCE();
        return true;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '@com.lightningkite.lightningdb.Index(' + ')';
      }
    }
    initMetadataForClass($, 'Index');
    IndexClass = $;
  }
  return IndexClass;
}
var ReferencesClass;
function References() {
  if (ReferencesClass === VOID) {
    class $ {
      constructor(references, reverseName) {
        reverseName = reverseName === VOID ? '' : reverseName;
        this.i3i_1 = references;
        this.j3i_1 = reverseName;
      }
      equals(other) {
        if (!(other instanceof References()))
          return false;
        var tmp0_other_with_cast = other instanceof References() ? other : THROW_CCE();
        if (!this.i3i_1.equals(tmp0_other_with_cast.i3i_1))
          return false;
        if (!(this.j3i_1 === tmp0_other_with_cast.j3i_1))
          return false;
        return true;
      }
      hashCode() {
        var result = imul(getStringHashCode('references'), 127) ^ this.i3i_1.hashCode();
        result = result + (imul(getStringHashCode('reverseName'), 127) ^ getStringHashCode(this.j3i_1)) | 0;
        return result;
      }
      toString() {
        return '@com.lightningkite.lightningdb.References(' + 'references=' + toString(this.i3i_1) + ', ' + 'reverseName=' + this.j3i_1 + ')';
      }
    }
    initMetadataForClass($, 'References');
    ReferencesClass = $;
  }
  return ReferencesClass;
}
var MultipleReferencesClass;
function MultipleReferences() {
  if (MultipleReferencesClass === VOID) {
    class $ {
      constructor(references, reverseName) {
        reverseName = reverseName === VOID ? '' : reverseName;
        this.k3i_1 = references;
        this.l3i_1 = reverseName;
      }
      equals(other) {
        if (!(other instanceof MultipleReferences()))
          return false;
        var tmp0_other_with_cast = other instanceof MultipleReferences() ? other : THROW_CCE();
        if (!this.k3i_1.equals(tmp0_other_with_cast.k3i_1))
          return false;
        if (!(this.l3i_1 === tmp0_other_with_cast.l3i_1))
          return false;
        return true;
      }
      hashCode() {
        var result = imul(getStringHashCode('references'), 127) ^ this.k3i_1.hashCode();
        result = result + (imul(getStringHashCode('reverseName'), 127) ^ getStringHashCode(this.l3i_1)) | 0;
        return result;
      }
      toString() {
        return '@com.lightningkite.lightningdb.MultipleReferences(' + 'references=' + toString(this.k3i_1) + ', ' + 'reverseName=' + this.l3i_1 + ')';
      }
    }
    initMetadataForClass($, 'MultipleReferences');
    MultipleReferencesClass = $;
  }
  return MultipleReferencesClass;
}
var UniqueClass;
function Unique() {
  if (UniqueClass === VOID) {
    class $ {
      equals(other) {
        if (!(other instanceof Unique()))
          return false;
        other instanceof Unique() || THROW_CCE();
        return true;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '@com.lightningkite.lightningdb.Unique(' + ')';
      }
    }
    initMetadataForClass($, 'Unique');
    UniqueClass = $;
  }
  return UniqueClass;
}
var AdminViewOnlyClass;
function AdminViewOnly() {
  if (AdminViewOnlyClass === VOID) {
    class $ {
      equals(other) {
        if (!(other instanceof AdminViewOnly()))
          return false;
        other instanceof AdminViewOnly() || THROW_CCE();
        return true;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '@com.lightningkite.lightningdb.AdminViewOnly(' + ')';
      }
    }
    initMetadataForClass($, 'AdminViewOnly');
    AdminViewOnlyClass = $;
  }
  return AdminViewOnlyClass;
}
var IndexSetClass;
function IndexSet() {
  if (IndexSetClass === VOID) {
    class $ {
      constructor(fields) {
        this.q3i_1 = fields;
      }
      equals(other) {
        if (!(other instanceof IndexSet()))
          return false;
        var tmp0_other_with_cast = other instanceof IndexSet() ? other : THROW_CCE();
        if (!contentEquals(this.q3i_1, tmp0_other_with_cast.q3i_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('fields'), 127) ^ hashCode(this.q3i_1);
      }
      toString() {
        return '@com.lightningkite.lightningdb.IndexSet(' + 'fields=' + toString(this.q3i_1) + ')';
      }
    }
    initMetadataForClass($, 'IndexSet');
    IndexSetClass = $;
  }
  return IndexSetClass;
}
var UniqueSetClass;
function UniqueSet() {
  if (UniqueSetClass === VOID) {
    class $ {
      constructor(fields) {
        this.r3i_1 = fields;
      }
      equals(other) {
        if (!(other instanceof UniqueSet()))
          return false;
        var tmp0_other_with_cast = other instanceof UniqueSet() ? other : THROW_CCE();
        if (!contentEquals(this.r3i_1, tmp0_other_with_cast.r3i_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('fields'), 127) ^ hashCode(this.r3i_1);
      }
      toString() {
        return '@com.lightningkite.lightningdb.UniqueSet(' + 'fields=' + toString(this.r3i_1) + ')';
      }
    }
    initMetadataForClass($, 'UniqueSet');
    UniqueSetClass = $;
  }
  return UniqueSetClass;
}
var AdminTableColumnsClass;
function AdminTableColumns() {
  if (AdminTableColumnsClass === VOID) {
    class $ {
      constructor(fields) {
        this.p3h_1 = fields;
      }
      equals(other) {
        if (!(other instanceof AdminTableColumns()))
          return false;
        var tmp0_other_with_cast = other instanceof AdminTableColumns() ? other : THROW_CCE();
        if (!contentEquals(this.p3h_1, tmp0_other_with_cast.p3h_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('fields'), 127) ^ hashCode(this.p3h_1);
      }
      toString() {
        return '@com.lightningkite.lightningdb.AdminTableColumns(' + 'fields=' + toString(this.p3h_1) + ')';
      }
    }
    initMetadataForClass($, 'AdminTableColumns');
    AdminTableColumnsClass = $;
  }
  return AdminTableColumnsClass;
}
var AdminTitleFieldsClass;
function AdminTitleFields() {
  if (AdminTitleFieldsClass === VOID) {
    class $ {
      constructor(fields) {
        this.q3h_1 = fields;
      }
      equals(other) {
        if (!(other instanceof AdminTitleFields()))
          return false;
        var tmp0_other_with_cast = other instanceof AdminTitleFields() ? other : THROW_CCE();
        if (!contentEquals(this.q3h_1, tmp0_other_with_cast.q3h_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('fields'), 127) ^ hashCode(this.q3h_1);
      }
      toString() {
        return '@com.lightningkite.lightningdb.AdminTitleFields(' + 'fields=' + toString(this.q3h_1) + ')';
      }
    }
    initMetadataForClass($, 'AdminTitleFields');
    AdminTitleFieldsClass = $;
  }
  return AdminTitleFieldsClass;
}
//region block: exports
export {
  AdminTableColumns as AdminTableColumns2kd3zhffh08h8,
  AdminTitleFields as AdminTitleFields119drm0zwfxoa,
  AdminViewOnly as AdminViewOnly2m1t9bs9xa6rn,
  Denormalized as Denormalizedb7mfi9hagcb1,
  Description as Description2bxny7ww0bbw3,
  DisplayName as DisplayName32zbf48594hse,
  DoesNotNeedLabel as DoesNotNeedLabel294wkz4b87zo,
  IndexSet as IndexSet1wbu7in7fosv3,
  Index as Index19x9ylte4qic1,
  Multiline as Multilineo47h3baoeckd,
  MultipleReferences as MultipleReferences1olws9tt2t5e6,
  References as References1cc2ge45k8vol,
  UniqueSet as UniqueSet327q26ziuapen,
  Unique as Unique2l35ftvvs34wx,
};
//endregion

//# sourceMappingURL=Annotations.mjs.map
